const DEFAULTCOLORS = ['#0062e3', '#FEB019', '#FF4560', '#00E34A']

export const defaultChartOptions = {
  theme: { mode: 'dark' },
  chart: { background: 'var(--table-header-bgcolor)', animations: { enabled: false}},
  stroke: { curve: 'smooth', width: 2,},
  markers: { size: 3, hover: { size: 4 }, strokeWidth: 0},
  colors: DEFAULTCOLORS,
  legend: {
    labels: { colors: '#f1f1f1', useSeriesColors: false },
    position: 'top',
    horizontalAlign: 'center'
  },
  fill: { opacity: 0.5 },
  grid: { borderColor: '#333' } //cor das linhas de grade do fundo
};

export const densityUnitsOptions = {
  //https://apexcharts.com/vue-chart-demos/area-charts/datetime-x-axis/
  //
  theme: { mode: 'dark' },
  legend: {show: false},
  chart: {
    id: 'area-datetime',
    background: 'var(--table-header-bgcolor)',
    type: 'area',
    zoom: {
      autoScaleYaxis: true
    }
  },
  stroke: { curve: 'smooth', width: 2 },
  colors: DEFAULTCOLORS,
  xaxis: {
    type: 'category',
  },
  tooltip: {
    shared: false,
    y: {
      formatter: (val) => val
    }
  },
};
